<template>
  <b-row>
    <SideBar
      :title="title"
      class="sidebar"
      :menuList="menuList"
      @reportTab="handleChangeTab"
      @searchReport="handleSearchChange"
    />
    <div class="content" style="margin-top: 0 !important">
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-row>
            <b-col md="4">
              <b-skeleton-img aspect="3:1" />
            </b-col>
            <b-col md="4">
              <b-skeleton-img aspect="3:1" />
            </b-col>
            <b-col md="4">
              <b-skeleton-img aspect="3:1" />
            </b-col>
          </b-row>
        </template>
        <div v-if="section == 'all'">
          <h5 class="mc-general__label">
            {{ `${$t('report.sideNav.all')} (${reportAll.length})` }}
          </h5>
          <ReportList
            v-for="sub in createCategory(filteredAll)"
            :key="sub.key"
            :title="`${sub.key ? $t(`report.report.subCategory.${sub.key}`) : ''}`"
            :list="sub.reports"
            class="my-3"
            @onDelete="onDelete"
          />
        </div>
        <div v-if="section == 'favorite'">
          <h5>{{ `${$t('report.sideNav.favorites')} (${listFavoriteReport.length})` }}</h5>
          <ReportList
            v-for="sub in createCategory(filteredFavorite)"
            :key="sub.key"
            :title="`${sub.key ? $t(`report.report.subCategory.${sub.key}`) : ''}`"
            :list="sub.reports"
            class="my-3"
            @onDelete="onDelete"
          />
        </div>
        <div v-if="section == 'saved'">
          <h5>{{ `${$t('report.sideNav.saved')} (${listSavedReport.length})` }}</h5>
          <ReportList
            v-for="sub in createCategory(filteredSaved)"
            :key="sub.key"
            :title="`${sub.key ? $t(`report.report.subCategory.${sub.key}`) : ''}`"
            :list="sub.reports"
            class="my-3"
            @onDelete="onDelete"
          />
        </div>
        <div v-if="section == 'fleet'">
          <h5>{{ `${$t('master.kendaraan')} (${reportFleet.length})` }}</h5>
          <ReportList
            v-for="sub in createCategory(filteredFleet)"
            :key="sub.key"
            :title="`${sub.key ? $t(`report.report.subCategory.${sub.key}`) : ''}`"
            :list="sub.reports"
            class="my-3"
            @onDelete="onDelete"
          />
        </div>
        <div v-if="section == 'delivery'">
          <h5>{{ `${$t('menuitems.delivery.text')} (${reportDelivery.length})` }}</h5>
          <ReportList
            :title="$t('menuitems.delivery.text')"
            :list="filteredDelivery"
            class="my-3"
            @onDelete="onDelete"
          />
        </div>
        <div v-if="section == 'driver'">
          <h5>{{ `${$t('global.driver')} (${reportDriver.length})` }}</h5>
          <ReportList
            :title="$t('global.driver')"
            :list="filteredDriver"
            class="my-3"
            @onDelete="onDelete"
          />
        </div>
      </b-skeleton-wrapper>
    </div>
    <b-modal id="modal-delete" class="mc-modal" size="md" :title="$t('report.object.deleteReport')">
      <p>{{ $t('report.text.deleteReportConfirm') }}</p>
      <template #modal-footer>
        <b-row class="modal__footer mx-0">
          <b-col sm="12" md="12" class="modal__footer-btn">
            <McButton
              variant="secondary"
              class="me-2"
              :text="$t('global.cancel')"
              @click="handleCancel"
            />
            <McButton variant="primary" :text="$t('global.delete')" @click="handleDelete" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </b-row>
</template>
<script>
import SideBar from './SideBar.vue'
import ReportList from './ReportList.vue'
import responsive from '@/mixin/responsive'
import { mapGetters } from 'vuex'
import { DELETE_SAVED_REPORT } from '@/services/api/report/report'
import McButton from '@/components/McButton'
import { getCustomReport } from '@/services/rest-api-identity/lib/metabase/custom'
import sideMenu from '../lib/sideBarList'

export default {
  components: {
    SideBar,
    ReportList,
    McButton,
  },
  mixins: [responsive],
  data() {
    return {
      section: 'all',
      isLoading: false,
      reportAll: [],
      reportFleet: [],
      reportDelivery: [],
      reportDriver: [],
      keyword: '',
      savedId: null,
      customList: [],
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    title() {
      return this.$t('menuitems.laporan.text')
    },
    list() {
      let reportList = this.$store.state.report.reports
      const orderedReportList = reportList.sort((a, b) => {
        // Sort in descending order, so isFavorite: true comes first
        if (a.isFavorite === b.isFavorite) {
          return 0
        }
        return b.isFavorite ? 1 : -1
      })

      return orderedReportList
    },
    listSavedReport() {
      return this.$store.state.report.savedReports
    },
    listFavoriteReport() {
      return this.list.filter((item) => item.isFavorite)
    },
    filteredFavorite() {
      if (this.keyword) {
        return this.listFavoriteReport.filter((item) => {
          const label = `${this.$t(item.label)}`.toLowerCase()
          const desc = (item.isDescDefault === false ? item.desc : this.$t(item.desc)).toLowerCase()
          return label.includes(this.keyword) || desc.includes(this.keyword)
        })
      }
      return this.listFavoriteReport
    },
    filteredSaved() {
      if (this.keyword) {
        return this.listSavedReport.filter((item) => {
          const label = (item.labelName || '').toLowerCase()
          const desc = (item.isDescDefault === false ? item.desc : this.$t(item.desc)).toLowerCase()
          return label.includes(this.keyword) || desc.includes(this.keyword)
        })
      }
      return this.listSavedReport
    },
    filteredAll() {
      if (this.keyword) {
        return this.reportAll.filter((item) => {
          const label = (item.labelName ?? this.$t(item.label)).toLowerCase()
          const desc = (item.isDescDefault === false ? item.desc : this.$t(item.desc)).toLowerCase()
          return label.includes(this.keyword) || desc.includes(this.keyword)
        })
      }
      return this.reportAll
    },
    filteredFleet() {
      if (this.keyword) {
        return this.reportFleet.filter((item) => {
          const label = (item.labelName ?? this.$t(item.label)).toLowerCase()
          const desc = (item.isDescDefault === false ? item.desc : this.$t(item.desc)).toLowerCase()
          return label.includes(this.keyword) || desc.includes(this.keyword)
        })
      }
      return this.reportFleet
    },
    filteredDelivery() {
      if (this.keyword) {
        return this.reportDelivery.filter((item) => {
          const label = (item.labelName ?? this.$t(item.label)).toLowerCase()
          const desc = (item.isDescDefault === false ? item.desc : this.$t(item.desc)).toLowerCase()
          return label.includes(this.keyword) || desc.includes(this.keyword)
        })
      }
      return this.reportDelivery
    },
    filteredDriver() {
      if (this.keyword) {
        return this.reportDriver.filter((item) => {
          const label = (item.labelName ?? this.$t(item.label)).toLowerCase()
          const desc = (item.isDescDefault === false ? item.desc : this.$t(item.desc)).toLowerCase()
          return label.includes(this.keyword) || desc.includes(this.keyword)
        })
      }
      return this.reportDriver
    },
    menuList() {
      sideMenu.forEach((item) => {
        if (item.section == 'all') item.total = this.reportAll.length
        if (item.section == 'favorite') item.total = this.listFavoriteReport.length
        if (item.section == 'saved') item.total = this.listSavedReport.length
        if (item.section == 'fleet') item.total = this.reportFleet.length
        if (item.section == 'delivery') item.total = this.reportDelivery.length
        if (item.section == 'driver') item.total = this.reportDriver.length
      })
      return sideMenu.filter((item) => !item.hidden)
    },
  },
  async mounted() {
    if (this.hasAccess(['custom_content:read'])) await this.getCustomReport()

    this.isLoading = true
    if (this.hasAccess(['saved-reports:read'])) {
      await this.$store.dispatch('report/setSavedReport')
    }
    let reportList = [
      ...this.$store.state.report.reports.filter((item) => !item.isCustom),
      ...this.customList,
    ]

    reportList = reportList.filter((item) => {
      if (!item.isCustom) {
        return (
          this.hasAccessAll(item.haveAccess) &&
          !this.hasAccessAll(item.haveNoAccess) &&
          (item.shown || item.shown === undefined)
        )
      } else {
        return item.isCustom
      }
    })
    this.$store.commit('report/updateReportList', reportList)
    this.initData()
    if (!this.mediaQuery.matches) {
      this.$store.dispatch('layout/toggleMenu', true)
    }
    this.isLoading = false
  },
  methods: {
    async getCustomReport() {
      const res = await getCustomReport()

      if (res?.data) {
        this.customList = res?.data.map((item) => {
          return {
            ...item,
            label: item.content_name,
            key: item.content_name.toLowerCase().replace(' ', '-'),
            isCustom: true,
            desc: item.description,
          }
        })
      }
    },

    onDelete(savedId) {
      this.$bvModal.show('modal-delete')
      this.savedId = savedId
    },
    handleCancel() {
      this.$bvModal.hide('modal-delete')
      this.savedId = null
    },
    async handleDelete() {
      if (this.savedId) {
        const deleteData = await this.$apollo.mutate({
          mutation: DELETE_SAVED_REPORT,
          variables: {
            input: {
              savedReportsId: this.savedId,
            },
          },
        })
        if (deleteData.data.deleteSavedReport.isSuccessful) {
          this.$mcToast.success(this.$t('report.text.reportSuccessDeleted'))
          this.handleCancel()
          setTimeout(() => {
            if (this.$route.query.domain) window.location.reload()
            else {
              this.$router.push({ name: 'Report', query: { domain: 'fleet' } }).then(() => {
                window.location.reload()
              })
            }
          }, 1000)
        } else {
          this.$mcToast.error(this.$t('report.text.reportFailedDeleted'))
        }
        this.deleteSaved = false
        this.saveId = null
      }
    },
    initData() {
      this.reportAll = this.list.concat(this.listSavedReport)

      this.reportFleet = this.list
        .filter((item) => item.category.includes('fleet'))
        .concat(this.listSavedReport.filter((item) => item.category.includes('fleet')))
      this.reportDelivery = this.list
        .filter((item) => item.category.includes('delivery'))
        .concat(this.listSavedReport.filter((item) => item.category.includes('delivery')))
      this.reportDriver = this.list
        .filter((item) => item.category.includes('driver'))
        .concat(this.listSavedReport.filter((item) => item.category.includes('driver')))
    },
    createCategory(report) {
      const result = []
      if (report.length > 0) {
        report.forEach((item) => {
          const isKeyExist = result.findIndex((item2) => item2.key === item.section)

          if (isKeyExist >= 0) {
            result[isKeyExist].reports.push(item)
          } else {
            result.push({
              key: item.section,
              reports: [item],
            })
          }
        })
      } else {
        result.push({
          key: '',
          reports: [],
        })
      }

      return result
    },
    handleChangeTab(data) {
      this.section = data
    },
    handleSearchChange(data) {
      this.isLoading = true
      const keyword = data.search.toLowerCase()
      this.keyword = keyword
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },
  },
}
</script>
<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: 90px;
  width: 320px;
  height: 100%;
}
.content {
  width: calc(100% - 320px);
  left: 320px;
  top: 0;
}
.modal-content,
.modal-header,
.modal-footer {
  border-radius: 0;

  .modal__footer-btn {
    display: flex;
  }
}
</style>
